<template>
  <div class="splitter"></div>
</template>

<script>
  export default {
    name: 'splitter',

    props: [],

    data: function () {
      return {

      }
    },

    mounted:function() {

    },

    beforeDestroy: function() {

    },

    methods: {

    },

    computed:{

    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_colors";

  .splitter {
    width: 100%;
    height: 0%;
    border-bottom: 1px solid @brand__grey2;
    margin: 3.5rem 0;
  }
</style>



// WEBPACK FOOTER //
// Splitter.vue?f7fc53dc